import React, { useEffect, useState, useRef } from 'react';
import styled from 'styled-components';
import moment from 'moment';

// Components
import { Search, Button } from 'carbon-components-react';
import LanguagesGrid from './LanguagesGrid';

// data


const LanguagesContent = ({
  languagesList,
  setOpenNewLanguageModal,
  setMode,
  user,
  setTriggerExport,
  triggerExport,
  onDeleteClicked,
  setDetailModalMode,
  setLanguage,
}) => {
  const [search, setSearch] = useState("");
  const onlyAttachment = localStorage.getItem('only_attachment')

  const rowClicked = (data) => {
    setDetailModalMode("update")
    setLanguage(data);
    setOpenNewLanguageModal(true)
  }

  return (
    <Container>
      <ContentHeader>
        <ActionBar>
            <div style={{ width: "300px" }}>
              <Search
                size="sm"
                value={search}
                labelText="search"
                onChange={e => setSearch(e.target.value)}
                placeHolderText="Search using any data value"
              />
            </div>

            <Button
                kind="primary"
                onClick={() => {
                  setOpenNewLanguageModal(true);
                  setMode("create");
                }}
                style={addStudyBtnStyle}
                disabled={onlyAttachment === "true"}
              >
              Add New Language
            </Button>
          </ActionBar>
      </ContentHeader>
    
      <LanguagesGridContainer>
        <LanguagesGrid
          user={user}
          search={search}
          languagesList={languagesList} 
          setTriggerExport={setTriggerExport}
          triggerExport={triggerExport}
          onDeleteClicked={onDeleteClicked}
          onRowClicked={rowClicked}
          />
      </LanguagesGridContainer>


    </Container>
  );
};

export default LanguagesContent;


const LanguagesGridContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: #fff;
`

const ActionBar = styled.div`
  width: 100%;
  height: fit-content;
  background-color: #fff;
  margin-bottom: 15px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`

const addStudyBtnStyle = {
  padding: "5px 10px",
  height: "30px",
  minHeight: "30px"
};

const Container = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-flow: column;
  background-color: #fff;
  padding: 24px;
`

const ContentHeader = styled.div`
  flex: 0 1 auto;
`